export default __webpack_public_path__ + "static/media/image6.e424892b.png";